import React, { useState } from 'react';
import { FormControl, InputAdornment, Typography, Box } from '@mui/material';
import clsx from 'clsx';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { StyledInputBase, StyledIconButton } from './styles';

const TextInput = ({
	className = {},
	required = false,
	label = '',
	type = 'text',
	name = '',
	margin = 'none',
	value = '',
	multiline = false,
	handleChange = () => {},
	rows = 1,
	placeholder = '',
	disabled = false,
	onKeyPress = () => {},
	autoComplete = 'off',
	endIcon,
	isClearable = false,
	isLoading = false,
	min,
	max,
	maxLength,
	...props
}) => {
	const [showPassword, setShowPassword] = useState(false);
	const [error, setError] = useState(false);

	const togglePasswordVisibility = () => {
		setShowPassword((prev) => !prev);
	};

	const handleInputChange = (ev) => {
		let { name, value } = ev.target;
		required && value === '' ? setError(true) : setError(false);
		handleChange(ev);
	};

	const getPasswordInputType = (type, showPassword) => {
		return (
			(type !== 'password' && type) ||
			(type === 'password' && showPassword && 'text') ||
			type
		);
	};

	return (
		<FormControl fullWidth className={clsx(className.root)}>
			<Typography
				variant="body2"
				color="textSecondary"
				className={clsx(className.label)}
			>
				{label}
			</Typography>
			<StyledInputBase
				error={error}
				rows={rows}
				className={clsx(className.inputBase)}
				multiline={multiline}
				autoComplete="off"
				fullWidth
				type={getPasswordInputType(type, showPassword)}
				name={name}
				margin={margin}
				disabled={disabled}
				placeholder={placeholder}
				onKeyPress={onKeyPress}
				variant="outlined"
				onChange={handleInputChange}
				inputProps={{
					min: type === 'date' ? min : undefined,
					max: type === 'date' ? max : undefined,
					maxLength: maxLength
				}}
				value={value}
				endAdornment={
					type === 'password' && (
						<InputAdornment position="end">
							<StyledIconButton onClick={togglePasswordVisibility}>
								{showPassword ? <VisibilityOff /> : <Visibility />}
							</StyledIconButton>
						</InputAdornment>
					)
				}
				{...props}
			/>
			{maxLength && (
				<Typography
					variant="caption"
					color="textSecondary"
					className={clsx(className.charCount)}
				>
					{`${value.length}/${maxLength} characters`}
				</Typography>
			)}
		</FormControl>
	);
};

export default TextInput;
